import React from 'react';
import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import StatsSection from './components/StatsSection';
import WorkSection from './components/WorkSection';
import ProjectSlider from './components/ProjectSlider';
import GallerySection from './components/GallerySection';
import StudioSection from './components/StudioSection';
import ServicesSection from './components/ServicesSection';
import ProcessSection from './components/ProcessSection';
import TestimonialsSection from './components/TestimonialsSection';
import AwardsSection from './components/AwardsSection';
import JournalSection from './components/JournalSection';
import CtaSection from './components/CtaSection';
import ContactSection from './components/ContactSection';
import SiteFooter from './components/SiteFooter';
import WhatsAppFloat from './components/WhatsAppFloat';
import './App.css';

function App() {
  return (
    <div className="site-shell">
      <SiteHeader />
      <main>
        <HeroSection />
        <IntroSection />
        <StatsSection />
        <WorkSection />
        <ProjectSlider />
        <GallerySection />
        <StudioSection />
        <ServicesSection />
        <ProcessSection />
        <TestimonialsSection />
        <AwardsSection />
        <JournalSection />
        <CtaSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
